import React, { useMemo, useState } from 'react';
import { AlertsView } from './Alerts.view';
import {
  DEMO_TEAM_OPTIONS,
  DEMO_EMPLOYEE_OPTIONS,
  DEMO_ALERTS,
} from './Alerts.demoData';

const allTeamsOption = {
  value: 'all-departments',
  label: 'All Departments',
  isAllTeams: true,
};
const allEmployeesOption = {
  value: 'all-employees',
  label: 'All Employees',
  isAllEmployees: true,
};

const teamOptions = [allTeamsOption, ...DEMO_TEAM_OPTIONS];
const employeeOptions = [allEmployeesOption, ...DEMO_EMPLOYEE_OPTIONS];

export const AlertsDemoComponent = () => {
  const [selectedTeam, setSelectedTeam] = useState(allTeamsOption);
  const [selectedEmployee, setSelectedEmployee] = useState(allEmployeesOption);

  const filteredAlerts = useMemo(() => {
    return DEMO_ALERTS.filter((alert) => {
      if (!selectedTeam?.isAllTeams && alert.teamId !== selectedTeam?.value) {
        return false;
      }
      if (selectedEmployee?.isAllEmployees) {
        return true;
      }
      if (selectedEmployee && alert.userId !== selectedEmployee.value) {
        return false;
      }
      return true;
    });
  }, [selectedTeam, selectedEmployee]);

  const groupedAlerts = useMemo(() => {
    return filteredAlerts.reduce((acc, alert) => {
      if (!acc[alert.userId]) {
        acc[alert.userId] = {
          ...alert,
          key: 'group-' + alert.userId,
          children: [],
        };
      }
      acc[alert.userId].children.push({ key: alert.id, ...alert });
      return acc;
    }, {});
  }, [filteredAlerts]);

  return (
    <AlertsView
      teamOptions={teamOptions}
      selectedTeam={selectedTeam}
      onTeamChange={(opt) => {
        if (opt.isAllTeams) {
          setSelectedEmployee(allEmployeesOption);
        }
        setSelectedTeam(opt);
      }}
      employeeOptions={employeeOptions}
      selectedEmployee={selectedEmployee}
      onEmployeeChange={(opt) => setSelectedEmployee(opt)}
      loading={false}
      filteredAlerts={filteredAlerts}
      groupedAlerts={groupedAlerts}
    />
  );
};
